import * as z from "zod";

export const sendToTriage = {
  name: "sendToTriage" as const,
  input: z.object({
    workOrderBatchId: z.string(),
    reason: z.enum([
      "damaged",
      "qa_fail",
      "wrong_input",
      "wrong_output",
      "missing_materials",
      "other",
    ]),
    notes: z.string().nullish(),
  }),
  output: z.object({ success: z.boolean() }),
};
